import React, { useRef, useState } from "react";
import { Button, Form } from "react-bootstrap";
import { Helmet } from "react-helmet";

import validators from 'shared/validators';
import { SALE_LIST_TYPE, SaleListHoc } from "../HOC/SaleListHoc";
import { Breadcrumbs } from "shared/hoc/breadcrumbs/Breadcrumbs";
import { BREADCRUMB_TYPE_CONFIG } from "shared/hoc/breadcrumbs/config";

import "./EstateSaleList.scss";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { Loader } from "shared/hoc/loader/Loader";

const EstateSaleList = (props) => {
    const dispatch = useDispatch()
    const statemaintenance = useSelector(state => state?.statemaintenance);

    const [search, setSearch] = useState(statemaintenance?.["Estate-Sale-List"]?.searchkey || {});
    const previousSearch = useRef({});

    const [estateSaleForm, setEstateSaleForm] = useState({
        zipcode: { value: '', error: '', validators: [validators.equalToLength(5)] },
        miles: { value: '', error: '', validators: [validators.required()] },
    })
    const [pageLoad, setpageLoad] = useState(true)
    
    useEffect(() => {
        setpageLoad(true)
        if (statemaintenance?.["Estate-Sale-List"]) {
            let data = statemaintenance?.["Estate-Sale-List"]
            setEstateSaleForm(data?.forminput || estateSaleForm);
            previousSearch.current = { ...data?.searchkey } || search
            setSearch({ ...data?.searchkey } || search)
            let pusttoStore = { ...statemaintenance }
            delete pusttoStore["EstateItemList"]
            dispatch({
                type: 'PUSH_TO_STATE', payload: pusttoStore
            });
        }
        setpageLoad(false)
    }, [])
    
    const onInputValidation = (event) => {
        if (event.target.name === 'zipcode') {
            if (isNaN(Number(event.target.value)))
                event.target.value = '';
        }

        let controlError = ""
        for (let validator of estateSaleForm[event.target.name].validators) {
            controlError = validator(event.target.value);
            if (controlError) break;
        }

        setEstateSaleForm(prevState => {
            const form = {...prevState};
            form[event.target.name].value = event.target.value;
            form[event.target.name].error = controlError;

            return form;
        });
    };

    const clearAll = () => {
        let pusttoStore = { ...statemaintenance }
        delete pusttoStore["Estate-Sale-List"] 
        dispatch({
            type: 'PUSH_TO_STATE', payload: pusttoStore
        });
        setEstateSaleForm({
            zipcode: {
                ...estateSaleForm?.zipcode,
                value: "",
                error: ""
            },
            miles: {
                ...estateSaleForm?.miles,
                value: "",
                error: ""
            }
        });

        if ( JSON.stringify({}) === JSON.stringify(previousSearch.current) ) {
            return;
        }

        setSearch({});
        previousSearch.current = {};
    }

    const onSearch = () => {
        let filter = [];
        
        Object.keys(estateSaleForm).forEach((key) => {
            let value = estateSaleForm[key].value;
            if ( value ) {            
                filter.push({ "field": key, "value": value, "op": "=", "join": "AND" });  
            }
        });

        const searchData = { filter };

        if ( JSON.stringify(searchData) === JSON.stringify(previousSearch.current) ) {
            return;
        }        
        let pusttoStore = { ...statemaintenance }
        pusttoStore["Estate-Sale-List"] = {
            forminput:estateSaleForm,
            searchkey:searchData
        }
        dispatch({
            type: 'PUSH_TO_STATE', payload: pusttoStore
        });
        setSearch(searchData);
        previousSearch.current = searchData; // Setting current search data. Used to restrict the api call when the user spams the search button.
    }
    if (pageLoad) {
        return (
            <Loader/>
        )
    }
    return (
        <div className="d-flex flex-column">
            <Helmet>
                <title>CTBids | Find Your Perfect Estate Sales</title>
                <meta name='description' content="Find antiques, art from the category list in the description" />
                <meta name="google-site-verification" content="PPiTWW_2xWSo19mPTsAyR2w2L4blIGf5dTyAmvknUrs" />
                <link rel="canonical" href={`https://ctbids.com/estate-sale/list`} />
            </Helmet>
            <Breadcrumbs props={props} type={BREADCRUMB_TYPE_CONFIG.ESTATE_SALE_LIST} />

            <div className="d-flex flex-grow-1 align-items-center estate-sale-list">
                <div className='estate-sale-header'>
                    <div className='heading'>Live Estate Sales organized by our Caring Transitions Teams</div>
                    <div className='sub-heading'>Go through the variety of Estate Sales to find treasures behind the closed doors. We host online or at-location auctions according to the ease of sellers. We also have Self Pick-up and Shipping options.</div>
                    <div className='search'>
                        <Form.Group className="zipcode" controlId="zipcode">
                            <label>Zip Code</label>
                            <Form.Control type="text" placeholder="Enter Zip code" aria-label='Enter zipcode' name="zipcode" value={estateSaleForm.zipcode.value} onChange={(event) => onInputValidation(event, "estateSaleForm")} />
                            <div style={{height: "20px"}}>
                                {
                                    estateSaleForm.zipcode.value && estateSaleForm.zipcode.error ? <small className="text-danger">{estateSaleForm.zipcode.error}</small> : null
                                }
                            </div>
                        </Form.Group>
                        <Form.Group className="radius" controlId="distance">
                            <label>Within the radius of</label>
                            <Form.Select role={"button"} as="select" placeholder="Select Distance" aria-label='Select Distance' name="miles" value={estateSaleForm.miles.value} onChange={(event) => onInputValidation(event, "estateSaleForm")}>
                                <option selected hidden>Select Distance</option>
                                <option value="5">5 Miles</option>
                                <option value="10">10 Miles</option>
                                <option value="25">25 Miles</option>
                                <option value="50">50 Miles</option>
                                <option value="100">100 Miles</option>
                                <option value="250">250 Miles</option>
                            </Form.Select>
                        </Form.Group>
                        <div className='estate-btn'>
                            <Button className='btn-grey-light' onClick={clearAll}>Reset</Button>
                            <Button className='btn-secondary' disabled={!(estateSaleForm.zipcode.value  || estateSaleForm.miles.value)} onClick={onSearch}>Search</Button>
                        </div>
                    </div>
                </div>
                <SaleListHoc props={props} type={SALE_LIST_TYPE.ESTATESALE} search={search} showAd={true} />
            </div>
        </div>
    )
};

export default EstateSaleList;